import React from 'react';
import { useNavigate } from 'react-router-dom';
import Session from 'supertokens-web-js/recipe/session';
import { LogOut } from 'lucide-react';

interface LogoutButtonProps {
  scrolled?: boolean;
}

const LogoutButton: React.FC<LogoutButtonProps> = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await Session.signOut();
      navigate('/auth');
    } catch (err) {
      navigate('/auth');
    }
  };

  return (
    <button
      onClick={handleLogout}
      className={`flex items-center gap-3 rounded-lg px-3 py-2 text-md bg-primary text-primary-foreground w-full`}
    >
      <LogOut className="h-4 w-4" />
      <span>Logout</span>
    </button>
  );
};

export default LogoutButton;